import { Dropdown, Placeholder, Stack } from 'react-bootstrap';

export const JobCardSkeleton = () => {
	return (
		<>
			<Stack className="posted-job-box mb-3 mb-xxl-4 h-auto">
				<div className="posted-job-box-content d-flex gap-3 gap-xl-5 position-relative">
					<Stack className="flex-1 gap-3">
						<div className="d-flex flex-column flex-md-row align-items-md-center gap-3">
							<div className="company-logo"></div>
							<Stack className="job-detail justify-content-center flex-1">
								<Placeholder animation="glow">
									<Placeholder xs={12} size="lg" />
									<Placeholder xs={12} size="sm" />
								</Placeholder>
							</Stack>
						</div>
						<div className="job-duration">
							<Placeholder animation="glow">
								<Placeholder xs={2} /> <Placeholder xs={2} />{' '}
							</Placeholder>
						</div>
						<div className="posted-job-box-description">
							<Placeholder animation="glow">
								<Placeholder xs={12} />
								<Placeholder xs={12} />
							</Placeholder>
						</div>
					</Stack>
					<div className="posted-job-actions">
						<Stack className="gap-2 gap-md-3 align-items-end">
							<div className="edit-action">
								<Dropdown>
									<Dropdown.Toggle
										variant="success"
										id="dropdown-basic"
										className="p-0 border-0 rounded-circle"
									></Dropdown.Toggle>
								</Dropdown>
							</div>
							<Placeholder.Button variant="primary" className="filled-btn rounded-pill lh-1" />
							<Placeholder.Button variant="primary" className="transparent-btn rounded-pill lh-1" />
							<Placeholder.Button variant="primary" className="filled-btn rounded-pill lh-1" />
						</Stack>
					</div>
				</div>
				<div className="posted-job-box-basic-info">
					<Placeholder animation="glow">
						<Placeholder xs={1} /> <Placeholder xs={2} /> <Placeholder xs={1} />{' '}
						<Placeholder xs={2} /> <Placeholder xs={2} />{' '}
					</Placeholder>
				</div>
			</Stack>

			<Stack className="posted-job-box mb-3 mb-xxl-4 h-auto">
				<div className="posted-job-box-content d-flex gap-3 gap-xl-5 position-relative">
					<Stack className="flex-1 gap-3">
						<div className="d-flex flex-column flex-md-row align-items-md-center gap-3">
							<div className="company-logo"></div>
							<Stack className="job-detail justify-content-center flex-1">
								<Placeholder animation="glow">
									<Placeholder xs={12} size="lg" />
									<Placeholder xs={12} size="sm" />
								</Placeholder>
							</Stack>
						</div>
						<div className="job-duration">
							<Placeholder animation="glow">
								<Placeholder xs={2} /> <Placeholder xs={2} />{' '}
							</Placeholder>
						</div>
						<div className="posted-job-box-description">
							<Placeholder animation="glow">
								<Placeholder xs={12} />
								<Placeholder xs={12} />
							</Placeholder>
						</div>
					</Stack>
					<div className="posted-job-actions">
						<Stack className="gap-2 gap-md-3 align-items-end">
							<div className="edit-action">
								<Dropdown>
									<Dropdown.Toggle
										variant="success"
										id="dropdown-basic"
										className="p-0 border-0 rounded-circle"
									></Dropdown.Toggle>
								</Dropdown>
							</div>
							<Placeholder.Button variant="primary" className="filled-btn rounded-pill lh-1" />
							<Placeholder.Button variant="primary" className="transparent-btn rounded-pill lh-1" />
							<Placeholder.Button variant="primary" className="filled-btn rounded-pill lh-1" />
						</Stack>
					</div>
				</div>
				<div className="posted-job-box-basic-info">
					<Placeholder animation="glow">
						<Placeholder xs={1} /> <Placeholder xs={2} /> <Placeholder xs={1} />{' '}
						<Placeholder xs={2} /> <Placeholder xs={2} />{' '}
					</Placeholder>
				</div>
			</Stack>

			<Stack className="posted-job-box mb-3 mb-xxl-4 h-auto">
				<div className="posted-job-box-content d-flex gap-3 gap-xl-5 position-relative">
					<Stack className="flex-1 gap-3">
						<div className="d-flex flex-column flex-md-row align-items-md-center gap-3">
							<div className="company-logo"></div>
							<Stack className="job-detail justify-content-center flex-1">
								<Placeholder animation="glow">
									<Placeholder xs={12} size="lg" />
									<Placeholder xs={12} size="sm" />
								</Placeholder>
							</Stack>
						</div>
						<div className="job-duration">
							<Placeholder animation="glow">
								<Placeholder xs={2} /> <Placeholder xs={2} />{' '}
							</Placeholder>
						</div>
						<div className="posted-job-box-description">
							<Placeholder animation="glow">
								<Placeholder xs={12} />
								<Placeholder xs={12} />
							</Placeholder>
						</div>
					</Stack>
					<div className="posted-job-actions">
						<Stack className="gap-2 gap-md-3 align-items-end">
							<div className="edit-action">
								<Dropdown>
									<Dropdown.Toggle
										variant="success"
										id="dropdown-basic"
										className="p-0 border-0 rounded-circle"
									></Dropdown.Toggle>
								</Dropdown>
							</div>
							<Placeholder.Button variant="primary" className="filled-btn rounded-pill lh-1" />
							<Placeholder.Button variant="primary" className="transparent-btn rounded-pill lh-1" />
							<Placeholder.Button variant="primary" className="filled-btn rounded-pill lh-1" />
						</Stack>
					</div>
				</div>
				<div className="posted-job-box-basic-info">
					<Placeholder animation="glow">
						<Placeholder xs={1} /> <Placeholder xs={2} /> <Placeholder xs={1} />{' '}
						<Placeholder xs={2} /> <Placeholder xs={2} />{' '}
					</Placeholder>
				</div>
			</Stack>

			<Stack className="posted-job-box mb-3 mb-xxl-4 h-auto">
				<div className="posted-job-box-content d-flex gap-3 gap-xl-5 position-relative">
					<Stack className="flex-1 gap-3">
						<div className="d-flex flex-column flex-md-row align-items-md-center gap-3">
							<div className="company-logo"></div>
							<Stack className="job-detail justify-content-center flex-1">
								<Placeholder animation="glow">
									<Placeholder xs={12} size="lg" />
									<Placeholder xs={12} size="sm" />
								</Placeholder>
							</Stack>
						</div>
						<div className="job-duration">
							<Placeholder animation="glow">
								<Placeholder xs={2} /> <Placeholder xs={2} />{' '}
							</Placeholder>
						</div>
						<div className="posted-job-box-description">
							<Placeholder animation="glow">
								<Placeholder xs={12} />
								<Placeholder xs={12} />
							</Placeholder>
						</div>
					</Stack>
					<div className="posted-job-actions">
						<Stack className="gap-2 gap-md-3 align-items-end">
							<div className="edit-action">
								<Dropdown>
									<Dropdown.Toggle
										variant="success"
										id="dropdown-basic"
										className="p-0 border-0 rounded-circle"
									></Dropdown.Toggle>
								</Dropdown>
							</div>
							<Placeholder.Button variant="primary" className="filled-btn rounded-pill lh-1" />
							<Placeholder.Button variant="primary" className="transparent-btn rounded-pill lh-1" />
							<Placeholder.Button variant="primary" className="filled-btn rounded-pill lh-1" />
						</Stack>
					</div>
				</div>
				<div className="posted-job-box-basic-info">
					<Placeholder animation="glow">
						<Placeholder xs={1} /> <Placeholder xs={2} /> <Placeholder xs={1} />{' '}
						<Placeholder xs={2} /> <Placeholder xs={2} />{' '}
					</Placeholder>
				</div>
			</Stack>
		</>
	);
};

export default JobCardSkeleton;
